/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80a80da20cd287029e367b477e01456c>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/commit';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/commit/24';

/**
 * __24px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Commit24Icon = function Commit24Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  if (fg('icon-object-migration')) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: NewIcon,
      appearance: "orangeBold",
      size: "24",
      label: label,
      testId: testId,
      LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
        label: label,
        testId: testId
      })
    });
  } else {
    return /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    });
  }
};
Commit24Icon.displayName = 'Commit24Icon';
export default Commit24Icon;